import React from 'react'
import { Fade, Menu, MenuItem } from '@mui/material'

import useStyles from './styles'

const ButtonMenu = ({
  id = 'button-menu',
  options = [],
  onSelect,
  children,
  className = null,
  selected = null,
  itemClasses = null,
  activeClass = null,
  origin = null,
  renderFunc = null,
  targetRef = null,
  menuClass = null,
  disabledOptions = [],
  disabled = false,
  extraMenuChildren = null,
  extraTopChildren = null,
  manual = false,
  open = false,
  onOpen = () => {},
  onClose = () => {},
  testid = 'test-button-menu',
  ...props
}) => {
  const rootRef = React.useRef(null)
  const [anchor, setAnchor] = React.useState(null)

  const classes = useStyles()

  const handleOpen = e => {
    e.stopPropagation()
    if (disabled) {
      return
    }

    if (options.length) {
      if (targetRef) {
        if (targetRef.current) {
          setAnchor(targetRef.current)
        }
      } else {
        setAnchor(e.currentTarget)
      }
    }
  }

  const handleSelect = (item, disabled) => {
    if (!disabled) {
      onSelect(item)
    }
    setAnchor(null)
  }

  const checkOptions = () => {
    let newKey
    let disabled
    return options.map((opt, i) => {
      // email and SMS will return array of objects, checking for those to display properly
      newKey = opt?.key ?? opt
      disabled =
        [null, false].includes(opt?.validated) || disabledOptions.includes(opt)
      return (
        <MenuItem
          key={i}
          selected={
            selected
              ? !opt?.key
                ? opt === selected
                : opt.key === selected
              : false
          }
          onClick={e => {
            e.stopPropagation()
            handleSelect(opt, disabled)
          }}
          classes={itemClasses}
          className={disabled ? classes.disabled : classes.item}
        >
          {renderFunc ? renderFunc(newKey) : newKey}
        </MenuItem>
      )
    })
  }

  const isOpen = React.useMemo(
    () => (manual ? open : Boolean(anchor)),
    [manual, open, anchor]
  )

  return (
    <>
      <div
        ref={rootRef}
        data-testid={testid}
        className={`${classes.wrapper} ${className} ${anchor && activeClass}`}
        onClick={e => {
          handleOpen(e)
          manual && onOpen(e)
        }}
      >
        {children}
      </div>

      {isOpen && (
        <Menu
          id={id}
          elevation={3}
          getContentAnchorEl={null}
          anchorEl={manual ? rootRef.current : anchor}
          open={isOpen}
          onClose={e => {
            e.stopPropagation()

            if (manual) {
              onClose(e)
              return
            }

            setAnchor(null)
          }}
          anchorOrigin={origin?.anchor}
          transformOrigin={origin?.transform}
          TransitionComponent={Fade}
          keepMounted
          className={menuClass}
          {...props}
        >
          {extraTopChildren &&
            extraTopChildren(e => {
              e.stopPropagation()
              setAnchor(null)
            })}

          {options && checkOptions()}

          {extraMenuChildren}
        </Menu>
      )}
    </>
  )
}

export default ButtonMenu
